import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const loadStore: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { storeApi },
) =>
  action$.pipe(
    ofType(actions.LOAD_STORE_ACTIONS.REQUESTED),
    switchMap(({ payload: { storeId } }) =>
      storeApi.getStoreById(storeId).pipe(
        switchMap(({ store }) => of(actions.loadStoreSucceeded(store))),
        catchError(error => {
          return of(actions.loadStoreFailed(error));
        }),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/EditStore/services/epics/loadStore.ts